import { getRuntimeConfig } from '../config/runtime-config';

/**
 * Console-local equivalent of `@shared/auth/auth-config.ts`, kept
 * separate specifically so it reads THIS app's lean
 * `ConsoleRuntimeConfig` rather than the operator SPA's -- see
 * `config/runtime-config.ts`'s own comment on why that type isn't
 * shared. Shape matches `@shared/auth/auth-config.ts::AuthConfig`
 * exactly so `ConsoleAuthProvider` can construct `oidc-client-ts`'s
 * `UserManager` the same way `ZitadelProvider` does.
 */
export interface AuthConfig {
  authority: string;
  clientId: string;
  scope: string;
  redirectUri: string;
  postLogoutRedirectUri: string;
  audience?: string;
}

export function loadAuthConfig(): AuthConfig {
  const cfg = getRuntimeConfig();
  if (cfg.authMode === 'mock') {
    return {
      authority: 'http://localhost:0/mock-oidc',
      clientId: 'mock-support-console',
      scope: 'openid profile email urn:zitadel:iam:org:project:roles',
      redirectUri: `${window.location.origin}/callback`,
      postLogoutRedirectUri: `${window.location.origin}/login`,
    };
  }
  return {
    authority: cfg.zitadel.issuer,
    clientId: cfg.zitadel.clientId,
    scope: cfg.zitadel.scopes.join(' '),
    redirectUri: cfg.zitadel.redirectUri,
    postLogoutRedirectUri: cfg.zitadel.postLogoutRedirectUri,
    audience: cfg.zitadel.audience,
  };
}
